import * as React from "react";

const TeamTitle = ({ record }) => {
  return <span>{`Team_Member - ${record.fullName}`}</span>;
};

export default TeamTitle;
